<script>
    import Cover from '@/Components/HomeComponents/Cover.vue'
    import { Link, usePage, router } from '@inertiajs/vue3'

    
    export default {
        components: {
            Cover,
            Link
        },
        props: {
            componentData: {
                type: Object,
                required: false,
                default: ()=>({
                    'canLogin': true,
                    'canRegister': true,
                })
            }
        },
        data() {
            
            if ( typeof this.$page.props.auth.user == "string" ){
                
                
                const { name, email } = this.$page.props.auth.user
                return {
                    name: name,
                    email: email,
                    isOpen: false,
                    canLogin: true,
                    canRegister: true,
                }

            } else if (typeof this.$page.props.canLogin != "undefined"){

                const { canLogin, canRegister } = this.$page.props
                return {
                    isOpen: false,
                    canLogin: canLogin,
                    canRegister,
                }

            }else {

                return {
                    isOpen: false,
                    canLogin: true,
                    canRegister: true,

                }

            }
        },
        methods: {
            toggle(){
                this.isOpen = !this.isOpen
            },
            beforeEnter(el) {
                el.style.transform = "translateY(-20px)";
                el.style.opacity = "0";
            },
            enter(el, done) {
                el.style.transition = "all 0.3s ease-in-out";
                el.style.transform = "translateY(0px)";
                el.style.opacity = "1";
                setTimeout(done, 300);
            },
            leave(el, done) {
                el.style.transition = "all 0.3s ease";
                el.style.transform = "translateY(-20px)";
                el.style.opacity = "0";
                setTimeout(done, 300);

            },
            submit(e){
                e.preventDefault()
                router.post('logout')
            },
        },


    }
    
</script>
<template>
    <div>
    <header />
        
        <!-- Navigation bar -->
        <nav  class="relative flex w-full items-center justify-between bg-white py-2 shadow-dark-mild dark:bg-body-dark lg:flex-wrap lg:justify-start lg:py-4"
                data-twe-navbar-ref>
                
            <div class="flex w-full flex-wrap items-center justify-between px-3">
                
                <div class="flex items-center">
                    <!-- Hamburger menu button -->
                    <button
                        @click="toggle"
                        class="border-0 bg-transparent px-2 text-xl leading-none transition-shadow duration-150 
                        ease-in-out hover:text-neutral-700 focus:text-neutral-700 dark:hover:text-white dark:focus:text-white 
                        lg:hidden"
                        type="button"
                        data-twe-collapse-init
                        data-twe-target="#navbarSupportedContentX"
                        aria-controls="navbarSupportedContentX"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <!-- Hamburger menu icon -->
                            <span class="[&>svg]:h-7 [&>svg]:w-7 [&>svg]:stroke-black/50 dark:[&>svg]:stroke-neutral-200">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor">
                                <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                                </svg>
                            </span>
                    </button>
                </div>

                <transition name="slide-fade"
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @leave="leave"
                >
                    <!-- Navigation links -->
                    <div v-show="isOpen" class="grow basis-[100%] items-center text-center lg:!flex lg:basis-auto lg:text-left"
                        id="navbarSupportedContentX" data-twe-collapse-item>

                        <!-- Menú con transición -->
                        <div class="flex items-center">
                            <img src="/assets/images/pachamamaobc_logo.png" alt="Logo" class="h-14 w-auto mr-4">
                        </div>
                        
                        <ul class="me-auto flex flex-col lg:flex-row" data-twe-navbar-nav-ref>
                            <li class="mb-4 lg:mb-0 lg:pe-2" data-twe-nav-item-ref>
                                
                                <Link class="block text-black/60 transition duration-200 hover:text-black/80 
                                            hover:ease-in-out focus:text-black/80 active:text-black/80 
                                            motion-reduce:transition-none dark:text-blue/60 
                                            dark:hover:text-blue/80 dark:focus:text-blue/80 dark:active:text-blue/80 lg:px-2" 
                                href="/">Inicio</Link>
                            </li>
                            
                            <li class="mb-4 lg:mb-0 lg:pe-2" data-twe-nav-item-ref>
                                <Link class="block text-black/60 transition duration-200 hover:text-black/80 
                                            hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none 
                                            dark:text-blue/60 dark:hover:text-blue/80 dark:focus:text-blue/80 
                                            dark:active:text-blue/80 lg:px-2"
                                :href="route('nosotros')" 
                                data-twe-nav-link-ref
                                data-twe-ripple-init
                                data-twe-ripple-color="light">Nosotros</Link>
                            </li>
                            <li class="mb-4 lg:mb-0 lg:pe-2" data-twe-nav-item-ref>
                                <Link class="block text-black/60 transition duration-200 hover:text-black/80 
                                            hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none 
                                            dark:text-blue/60 dark:hover:text-blue/80 dark:focus:text-blue/80 
                                            dark:active:text-blue/80 lg:px-2"
                                :href="route('agendar.tour.charla')" 
                                data-twe-nav-link-ref
                                data-twe-ripple-init
                                data-twe-ripple-color="light">Tour Ecológico Ambiental</Link>
                            </li>
                            <!--
                            <li class="mb-2 lg:mb-0 lg:pe-2" data-twe-nav-item-ref>
                                <Link class="block text-black/60 transition duration-200 hover:text-black/80 
                                            hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none 
                                            dark:text-blue/60 dark:hover:text-blue/80 dark:focus:text-blue/80 
                                            dark:active:text-blue/80 lg:px-2"
                                href="/actividades"
                                data-twe-nav-link-ref
                                data-twe-ripple-init
                                data-twe-ripple-color="light">Actividades</Link>
                            </li>
                            <li class="mb-2 lg:mb-0 lg:pe-2" data-twe-nav-item-ref>
                                <Link class="block text-black/60 transition duration-200 hover:text-black/80 
                                            hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none 
                                            dark:text-blue/60 dark:hover:text-blue/80 dark:focus:text-blue/80 
                                            dark:active:text-blue/80 lg:px-2"
                                href="/contactar"
                                data-twe-nav-link-ref
                                data-twe-ripple-init
                                data-twe-ripple-color="light">Contactar</Link>
                            </li>
                            -->
                        </ul>
                        <div v-if="canLogin">
                            <Link
                                v-if="$page.props.auth.user"
                                :href="route('dashboard')"
                                class="rounded-md px-3 py-2 text-black ring-1 ring-transparent transition hover:text-black/70 focus:outline-none focus-visible:ring-[#FF2D20] dark:text-white dark:hover:text-white/80 dark:focus-visible:ring-white"
                                >
                                    Dashboard
                            </Link>
                            <Link
                                v-if="$page.props.auth.user"
                                href="#"
                                v-on:click="submit"
                                class="rounded-md px-3 py-2 text-black ring-1 ring-transparent transition hover:text-black/70 focus:outline-none focus-visible:ring-[#FF2D20] dark:text-white dark:hover:text-white/80 dark:focus-visible:ring-white"
                                >
                                    Cerrar
                            </Link>
                            
                            <div v-else>
                                <Link
                                    :href="route('login')"
                                    class="rounded-md px-3 py-2 text-black ring-1 ring-transparent transition hover:text-black/70 focus:outline-none focus-visible:ring-[#FF2D20] dark:text-white dark:hover:text-white/80 dark:focus-visible:ring-white"
                                >
                                    Ingresar
                                </Link>
                                
                                <!-- <Link
                                    v-if="canRegister"
                                    :href="route('register')"
                                    class="rounded-md px-3 py-2 text-black ring-1 ring-transparent transition hover:text-black/70 focus:outline-none focus-visible:ring-[#FF2D20] dark:text-white dark:hover:text-white/80 dark:focus-visible:ring-white"
                                >
                                    Registro
                                </Link> -->
                            </div>
                        </div>
                        
                    </div>
                    
                </transition>
            </div>
        </nav>
    </div>
    
</template>

<style scoped>
/* Estilos para la animación */
.nav-link {
    display: block;
    padding: 8px 16px;
    color: #333;
    font-weight: 500;
    transition: color 0.3s ease;
}
.nav-link:hover {
    color: #007bff;
}

/* Transición de Vue */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 1s ease-in-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
    transition: all 5s ease-in-out;
    transform: translateY(-20px);
    opacity: 0;
}
</style>
